import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { coerceBoolean, PlatformService } from "@obg/ngx.global.evo";
import { lightFormat } from "date-fns";
import { interval, Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

import { RegulatoryItemsConfigService } from "../regulatory-items.config";

@Component({
	selector: "obg-standard-regulatory-items-component",
	templateUrl: "./standard-regulatory-items.component.html",
	styleUrls: ["./standard-regulatory-items.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class StandardRegulatoryItemsComponent implements OnInit {
	@HostBinding("class.obg-standard-regulatory-items-component") hostCssClass = true;

	@HostBinding("class.obg-standard-regulatory-items-component-ingame")
	@Input()
	@coerceBoolean()
	inGame = false;

	time$: Observable<string | undefined> | undefined;
	isRegulatoryItemsClockVisible$ = this.regulatoryItemsConfigService.isRegulatoryItemsClockVisible$();
	isRegulatoryItemsSessionTimerVisible$ = this.regulatoryItemsConfigService.isRegulatoryItemsSessionTimerVisible$();

	constructor(
		private platformService: PlatformService,
		private regulatoryItemsConfigService: RegulatoryItemsConfigService
	) {}

	ngOnInit() {
		this.time$ = this.platformService.forClient(() =>
			interval(1000).pipe(
				map(() => lightFormat(new Date(), "HH:mm")),
				distinctUntilChanged()
			)
		);
	}
}
